import { GET, cpBaseUrl, PUT } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';

export const reviewsListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/reviews${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const editReviewsListingApi = (params = '', id) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/reviews/${id}/edit${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateReviewApi = (id, reviewData) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/reviews/${id}`;
    NetworkManager.performRequest(url, reviewData, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
